module.exports = __webpack_public_path__ + "static/Group 467-b22c67bd02ec5342fd2842ac6a7d0ae1.png";